class HorizontalScroll extends HTMLDivElement {
  private scrollStarted: boolean = false;
  private hideScrollClass = 'hide-scroll';

  connectedCallback() {
    this.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
  }

  handleScroll() {
    if (this.scrollStarted) return;
    this.scrollStarted = true;

    // Show scrollbar by removing the hiding class
    this.classList.remove(this.hideScrollClass);
  }
}

if (!customElements.get('horizontal-scroll')) {
  customElements.define('horizontal-scroll', HorizontalScroll, { extends: 'div' });
}
